import axios from "axios";

import { getCookie } from "../utils/cookies.js";
const { protocol, host } = window.location; // 協議、主機
const reg = /^localhost+/;

console.log(window.location);
let currentEnv = process.env.VUE_APP_ENV;
let subURLPortal = "ccdc";
let logoutURLPortal = "pa4itp";
let logoutAxios = "";
let cookieName = "csrftoken";
const subURL = process.env.VUE_APP_URL != "" ? process.env.VUE_APP_URL : protocol;
export let isMockJs = currentEnv === "mock" ? true : false;

let logoutBaseUrl = "";

console.log(protocol, host, isMockJs);

console.log("currentEnv", currentEnv);

import store from "@/store";
import { MODAL, FORBITURL } from "@/enum/global";

if (reg.test(host)) {
  // 本機開發
  if (isMockJs) {
    //mock server
    axios.defaults.baseURL = "http://localhost:8015/";
    logoutBaseUrl = "http://localhost:8015/";
  } else {
    //172 server
    axios.defaults.baseURL = `${subURL}/${subURLPortal}/`;
    logoutBaseUrl = `${subURL}/${logoutURLPortal}/`;
  }
} else {
  // 動態請求地址
  if (currentEnv == "uat") {
    subURLPortal = "ccdc-uat";
    logoutURLPortal = "pa4itp-uat";
    axios.defaults.baseURL = `${protocol}//${host}/${subURLPortal}/`;
    logoutBaseUrl = `${protocol}//${host}/${logoutURLPortal}/`;
  } else if (currentEnv == "mock") {
    //for ATD stable  || currentEnv == 'develop'
    axios.defaults.baseURL = "http://localhost:8015/";
    logoutBaseUrl = "http://localhost:8015/";
  } else {
    axios.defaults.baseURL = `${protocol}//${host}/${subURLPortal}/`;
    logoutBaseUrl = `${protocol}//${host}/${logoutURLPortal}/`;
  }
}
console.log("axios.defaults.baseURL", axios.defaults.baseURL);
export let axiosDefaultsURL = axios.defaults.baseURL;

//變數config
let auth = process.env.VUE_APP_AUTH;
let token = "";
switch (currentEnv) {
  //develop先檢查 session cookie() 再檢查getCookie(csrftoken) basic auth
  //develop 測權限不足(403)時可以打開，因為線上cookie和 預設的 auth會衝突
  //意思是download 吃的是真正的cookie ，不是我們下在面的假auth
  //關掉的缺點是大家要看dev全縣就要輪切來切去很煩
  case "uat":
    //在dev 測試uat 時使用env.develop的VUE_APP_AUTH
    cookieName = cookieName + "_uat";
    break;
}

let isNeedLoading = (flag, url) => {
  let isNeeded = true;
  for (let i = 0; i < FORBITURL.length; i++) {
    if (url.indexOf(FORBITURL[i]) > -1) {
      //沒有禁止loading的url
      isNeeded = false;
    }
  }
  if (isNeeded) {
    if (flag) {
      store.commit("common/setLoading", true);
    } else {
      store.commit("common/setLoading", false);
    }
  }
};

axios.interceptors.request.use(
  config => {
    isNeedLoading(true, config.url);

    apiHandler.methods.setApiURL(config.url);
    apiHandler.methods.consoleTest();
    if (reg.test(host)) {
      if (isMockJs) {
        tokenConfig(config);
      } else {
        tokenConfig(config);
      }
    } else {
      //動態
      // console.log('cookieName',cookieName)
      token = getCookie(cookieName);
      // console.log('token',token)
      if (config.method == "head") {
        config.withCredentials = false;
        delete axios.defaults.headers.common["Authorization"];
        delete config.headers["X-CSRFToken"];
      } else {
        config.headers["X-CSRFToken"] = token;
        config.withCredentials = true;
        if (currentEnv == 'develop') {
          //FTP, stage：依 sessionid 決定身分
          let sessionid = getCookie("sessionid");
          config.headers.Authorization = sessionid ? token : auth;
        } else {
          config.headers.Authorization = token;
        }
      }
      // console.log(config.headers)
      // config.withCredentials = true;
    }
    return config;
  },
  error => Promise.reject(error)
);

axios.interceptors.response.use(
  response => {
    isNeedLoading(false, response.config.url);
    if (currentEnv === "mock") {
      //測試錯誤彈跳視窗用
      // response.status = 500
      // apiHandler.methods.errorModal(response.status,response)
    }
    return response;
  },
  error => {
    isNeedLoading(false, error.config.url);

    if (error.response.config.method == "head") {
      console.log("head");
      // apiHandler.methods.errorDownloadModal(200) //測試下載連結不正確彈跳視窗用

      apiHandler.methods.errorDownloadModal(error.response.status);
    } else {
      apiHandler.methods.errorModal(error.response.status, error);
    }
    // console.log('ERRORRRRR',error.response.config.method)
    // errorHandler(error);

    if (!window.navigator.onLine) {
      alert("網路出了點問題，請重新連線後重整網頁");
      return;
    }
    return Promise.reject(error);
  }
);

function tokenConfig(config) {
  if (auth) {
    if (config.method == "head") {
      delete axios.defaults.headers.common["Authorization"];
      delete config.headers["X-CSRFToken"];
    } else {
      config.headers["X-CSRFToken"] = auth;
      config.headers.Authorization = auth;
    }
    // console.log(config.headers)
  } else {
    token = getCookie("csrftoken");
    config.headers.Authorization = token;
    config.headers["X-CSRFToken"] = token;
  }
  return config;
}

export default function(method, url, data = null, config) {
  method = method.toLowerCase();
  switch (method) {
    case "post":
      return axios.post(url, data, config);
    case "get":
      return axios.get(url, { params: data });
    case "getlogout":
      axios.defaults.baseURL = logoutBaseUrl;
      logoutAxios = axios.get(url, { params: data });
      axios.defaults.baseURL = axiosDefaultsURL;
      return logoutAxios;
    case "delete":
      return axios.delete(url, { data: data });
    // return axios.delete(url, { params: data });
    case "put":
      return axios.put(url, data);
    case "patch":
      return axios.patch(url, data);
    case "head":
      return axios.head(url);
    default:
      console.log(`未知的 method: ${method}`);
      return false;
  }
}

export let apiHandler = {
  // store,
  data() {
    return {
      tempUrl: ""
    };
  },
  methods: {
    consoleTest() {
      // console.log('opops',store.state.setting.logoutLink)
    },
    setApiURL(v) {
      // console.log('logoutLink',store.state.user )
      this.tempUrl = v;
    },
    errorModal(errorCode, error) {
      // console.log('???',this.tempUrl,errorCode,store.state.setting)
      // console.log('???',this.tempUrl)
      switch (errorCode) {
        case 400:
        case 404:
        case 405:
        case 500:
        case 502:
          console.log("common error", errorCode);
          //有獨立的錯誤視窗，雖然共用錯誤碼
          //為true的話，error modal 就跳個別頁面的錯誤視窗，false就用通用的
          setTimeout(() => {
            if (!store.state.modal.singlePageAlert) {
              store.commit("modal/setShowModal", true);
              store.commit("modal/setType", MODAL[errorCode]);
            }
          }, 500);
          //     store.commit('modal/setSinglePageAlert', false);
          break;
        case 401:
        case 403: //第一次login me的可能沒有，login me要在main.js判斷，之後靠這邊轉導
          setTimeout(() => {
            store.commit("user/setErrorCookie", true);
          }, 1);
          setTimeout(() => {
            this.logoutLink();
          }, 500);
          break;
        case 503:
          if (error.response.headers["maintenance-type"]) {
            const maintenanceType = error.response.headers["maintenance-type"];
            if (maintenanceType === "announcement") {
              location.reload();
            }
          }
          break;
      }
    },
    errorDownloadModal(errorCode) {
      //檢查下載對象是否為可行
      switch (errorCode) {
        case 403:
        case 404:
          if (!store.state.modal.singlePageAlert) {
            store.commit("modal/setShowModal", true);
            store.commit("modal/setType", MODAL["download" + errorCode]);
          }
          break;
      }
    },
    logoutLink() {
      if (store.getters["setting/getNextLink"]) {
        window.location.href = store.getters["setting/getNextLink"]; //安全性轉
      }
    }
  }
};

export function beforeLoadFu() {
  console.log("1");
  let fetchAuth = auth;
  let fetchToken = token;
  let subDelete = isMockJs ? "users/survey-delete" : "users/me/survey-required/";
  let url = axios.defaults.baseURL + subDelete;
  if (reg.test(host)) {
    fetchAuth = auth;
    fetchToken = token;
    fetch(`${url}`, {
      keepalive: true,
      method: "DELETE",
      headers: {
        Authorization: fetchAuth,
        "Content-Type": "application/json",
        "X-CSRFToken": `${fetchToken}`
      }
    });
  } else {
    //動態
    token = getCookie(cookieName);
    console.log("cookieName", cookieName);
    if (currentEnv == "develop") {
      //FTP, stage
      fetch(`${url}`, {
        keepalive: true,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "X-CSRFToken": `${fetchToken}`
        }
      });
    } else {
      fetchAuth = token;
      fetch(`${url}`, {
        keepalive: true,
        method: "DELETE",
        headers: {
          Authorization: fetchAuth,
          "Content-Type": "application/json",
          "X-CSRFToken": `${fetchToken}`
        }
      });
    }
  }
  console.log("axios.defaults.baseURL", axios.defaults.baseURL);

  console.log("auth", auth, token);
  console.log("axios.defaults.baseURL", url);
}

//另外一種管理辦法，把url定義出來然後import進來
//function寫在這頁裡面
// import * as url from "./urlConfig";

// export const userApi = {
//     // 取得訂單資訊
//     getBillInfo(sendData) {
//         return axios.post(url.user.bill, sendData).then(response => response.data);
//     },
// };
